import React, { Component, Fragment } from 'react';
import { ScrollView, FlatList, View, TouchableOpacity } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import {
  VFText,
  FilterBar,
  Shimmer,
  ErrorScreen,
  VFBanner,
  SectionHeader,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';
import {
  AutoTopUpCard,
  BalanceItem,
  balanceLoadingConfig,
  shimmerPlaceholderConfig,
} from '../../Components';
import NoBalaceHistory from '../NoBalanceHistory/NoBalanceHistory';

import styles from './Balance.Styles';

class Balance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      selectedCategories: [],
      balanceItems: {},
      hasDatesFilter: false,
    };
  }

  componentDidMount() {
    this.props.getBalanceData();
    this.handleFilterBalance(this.state.selectedCategories);
    this.getCategories();
  }

  componentDidUpdate(prevProps) {
    const { balanceData, dateFilterPeriod, getBalanceFilteredData } = this.props;
    if (!_.isEqual(prevProps.balanceData, balanceData)) {
      this.handleFilterBalance(this.state.selectedCategories);
      this.getCategories();
    }
    if (!_.isEqual(prevProps.dateFilterPeriod, dateFilterPeriod) && !_.isEmpty(dateFilterPeriod)) {
      getBalanceFilteredData(
        dateFilterPeriod.start,
        dateFilterPeriod.end ?? dateFilterPeriod.start, // set 'end' value with the 'start' value if undfiend
      );
      this.setState({
        hasDatesFilter: true,
      });
      this.handleFilterBalance();
    }
  }

  onResetDatesFilter = () => {
    this.props.getBalanceData();
    this.setState({
      hasDatesFilter: false,
    });
    this.props.dateFilterPeriod.selectedPeriod = '';
  };

  getCategories = () => {
    const { balanceData } = this.props;
    let categoriesList = [];

    _.forEach(balanceData, value => {
      const items = _.get(value, 'items', []);
      if (_.isArray(items) && items.length && this.isValidCategory(value)) {
        categoriesList = _.concat(categoriesList, value);
      }
    });

    this.setState({
      categories: categoriesList,
    });
  };

  formateData = filteredData => {
    let allItems = [];
    const formatedData = {};
    const { start, end } = this.props.dateFilterPeriod;
    const { renderTimePeriodNoBalanceHistory } = this.props;

    _.forEach(filteredData, value => {
      const items = _.get(value, 'items', []);
      if (_.isArray(items) && items.length && this.isValidCategory(value)) {
        allItems = _.concat(allItems, value.items);
      }
    });

    const sortedItems = _.reverse(_.sortBy(allItems, item => item.date));
    const { dateFormats, dateTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;

    if (this.state.hasDatesFilter && _.isFunction(renderTimePeriodNoBalanceHistory)) {
      _.forEach(sortedItems, item => {
        if (
          moment(item.date).isBetween(
            dateTransformer(moment(start), dateFormats.calendarFormat),
            dateTransformer(moment(end ?? start), dateFormats.calendarFormat),
            'days',
            '[]',
          )
        ) {
          if (
            dateTransformer(moment(item.date), dateFormats.calendarFormat) ===
            dateTransformer(moment(), dateFormats.calendarFormat)
          ) {
            this.fillData(formatedData, '_Today', item);
          } else if (
            dateTransformer(moment(item.date), dateFormats.calendarFormat) ===
            moment().subtract(1, 'days').date()
          ) {
            this.fillData(formatedData, '_Yesterday', item);
          } else {
            this.fillData(
              formatedData,
              `_${dateTransformer(item.date, dateFormats.dayAndMonthName)}`,
              item,
            );
          }
        }
      });
    } else {
      _.forEach(sortedItems, item => {
        if (moment(item.date).year() !== moment().year()) {
          this.fillData(formatedData, `_${moment(item.date).year()}`, item);
        } else if (moment(item.date).month() !== moment().month()) {
          this.fillData(
            formatedData,
            `_${dateTransformer(item.date, dateFormats.monthNameAndYear)}`,
            item,
          );
        } else if (
          moment(item.date).date() !== moment().date() &&
          moment(item.date).date() !== moment().subtract(1, 'days').date()
        ) {
          this.fillData(
            formatedData,
            `_${dateTransformer(item.date, dateFormats.dayAndMonthName)}`,
            item,
          );
        } else if (moment(item.date).date() === moment().subtract(1, 'days').date()) {
          this.fillData(formatedData, '_Yesterday', item);
        } else {
          this.fillData(formatedData, '_Today', item);
        }
      });
    }

    this.setState({
      balanceItems: formatedData,
    });
  };

  fillData = (formatedData, time, item) => {
    if (formatedData[time]) {
      formatedData[time].push(item);
    } else {
      formatedData[time] = [item];
    }
  };

  isValidCategory = category => {
    return category.id && category.name && category.items && _.isArray(category.items);
  };

  setSelectedCategories = categoryId => {
    const { selectedCategories } = this.state;
    // See all
    // empty the selectedCategories
    if (!categoryId) {
      this.setState({ selectedCategories: [] }, () => {
        this.handleFilterBalance();
      });
      return;
    }

    // When press on a catagory that is not included in the filter
    // add it to the selectedCategories
    if (!_.includes(selectedCategories, categoryId)) {
      this.setState({ selectedCategories: [...this.state.selectedCategories, categoryId] }, () => {
        this.handleFilterBalance(categoryId);
      });
    } else {
      // When press on a catagory that is included in the filter
      // remove it from the selectedCategories
      this.setState(
        {
          selectedCategories: [...selectedCategories.filter(c => c !== categoryId)],
        },
        () => {
          this.handleFilterBalance(categoryId);
        },
      );
    }
  };

  handleFilterBalance = categoryId => {
    const { selectedCategories } = this.state;
    const { balanceData } = this.props;
    let filteredBalance = balanceData;

    if (categoryId && selectedCategories.length) {
      filteredBalance = balanceData.filter(item => {
        return _.includes(selectedCategories, item.id);
      });
    }

    this.formateData(filteredBalance);
  };

  handleBalanceHistoryDatesPress = () => {
    const { dateFilterPeriod, onBalanceHistoryDatesPress } = this.props;
    const { hasDatesFilter } = this.state;
    onBalanceHistoryDatesPress(hasDatesFilter && dateFilterPeriod);
  };

  renderLoading = isLoading =>
    isLoading ? (
      <Shimmer config={balanceLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    ) : null;

  renderErrorState = (isError, isLoading, onTryAgainPress) =>
    isError && !isLoading ? (
      <ErrorScreen
        text="balance_screen_error_message"
        textButton="balance_screen_try_again"
        iconStyle={styles.errorIconStyle}
        onPress={onTryAgainPress}
      />
    ) : null;

  renderCategories = (
    withCategories,
    categories,
    selectedCategories,
    setSelectedCategories,
    isLoading,
    isError,
  ) =>
    !withCategories || (!isLoading && isError) ? null : (
      <FilterBar
        setSelectedCategories={setSelectedCategories}
        selectedCategories={selectedCategories}
        filterData={categories}
        isLoading={isLoading}
        containerStyle={styles.filterContainerStyle}
      />
    );

  renderBalanceList = (isError, isLoading) => {
    if (isError || isLoading) {
      return null;
    }

    const { balanceItems } = this.state;
    const { theme } = this.props;
    const balanceList = [];

    _.forEach(balanceItems, (items, key) => {
      balanceList.push(
        <Fragment key={key}>
          <VFText
            i18nKey={_.split(key, '_')[1]}
            style={styles.subHeaderTitle(theme)}
            testKey={FrameworkTestKeys.BalanceHistoryBalanceItemsHeaderText}
          />
          <View
            style={styles.divider(theme)}
            testID={FrameworkTestKeys.BalanceHistoryBalanceItemsListView}
          />
          <FlatList
            data={items}
            renderItem={this.renderItems}
            keyExtractor={item => item.id}
            listKey={key}
            testID={FrameworkTestKeys.BalanceHistoryBalanceItemsList}
          />
        </Fragment>,
      );
    });

    return balanceList;
  };

  renderItems = ({ item }) => {
    if (_.isEmpty(item)) {
      return null;
    }
    return (
      <BalanceItem
        title={item.title}
        date={item.date}
        duration={item.duration}
        price={item.price}
        type={item.type}
        icon={item.icon}
        images={this.props.images}
        recurring={item.recurring}
        transactionStatus={item.transactionStatus}
      />
    );
  };

  render() {
    const {
      withCategories,
      theme,
      withTray,
      containerStyle,
      isNoBalanceHistory,
      balanceData,
      isError,
      isLoading,
      onTryAgainPress,
      autoTopUpBannerProps,
      withAutoTopUpBanner,
      withAutoTopUpCard,
      autoTopUpCardProps,
      dateFilterPeriod,
      withCategoriesDivider,
      renderTimePeriodNoBalanceHistory,
    } = this.props;
    const { categories, balanceItems, selectedCategories } = this.state;
    const frameworkImages = getThemeImages(theme.name);
    return (_.isEmpty(dateFilterPeriod) || !_.isFunction(renderTimePeriodNoBalanceHistory)) &&
      (isNoBalanceHistory || _.isEmpty(balanceData) || _.isEmpty(balanceItems)) &&
      !isError ? (
      <NoBalaceHistory />
    ) : (
      <ScrollView
        scrollEnabled={!isLoading && !isError}
        style={[styles.container, containerStyle]}
        contentContainerStyle={styles.scrollViewContainerStyle(withTray)}
        testID={FrameworkTestKeys.BalanceHistory}
      >
        {
          // DEPRECATEME: since [Release 22]
          withAutoTopUpBanner && (
            <VFBanner {...autoTopUpBannerProps} containerViewStyle={styles.containerViewStyle} />
          )
          // End Deprecation
        }

        {withAutoTopUpCard && <AutoTopUpCard {...autoTopUpCardProps} />}

        <SectionHeader
          theme={theme}
          style={styles.headerContainer}
          title="balance_history_title"
          titleStyle={styles.headerTitle(theme)}
          onRightSectionPress={this.handleBalanceHistoryDatesPress}
        />

        {this.state.hasDatesFilter && (
          <View
            style={styles.dateFilterInfoContainer}
            testID={FrameworkTestKeys.BalanceHistoryDatesFilterView}
          >
            <VFText
              i18nKey={`${dateFilterPeriod?.selectedPeriod}`}
              style={styles.dateFilterRange(theme)}
              testKey={FrameworkTestKeys.BalanceHistoryDatesFilterText}
            />
            <TouchableOpacity
              onPress={() => this.onResetDatesFilter()}
              testID={FrameworkTestKeys.BalanceHistoryDatesFilterClearButton}
            >
              <VFText
                i18nKey={'balance_screen_date_filter_clear_button_title'}
                style={styles.dateFilterClear(theme)}
                testKey={FrameworkTestKeys.BalanceHistoryDatesFilterClearButtonText}
              />
            </TouchableOpacity>
          </View>
        )}

        {this.renderCategories(
          withCategories,
          categories,
          selectedCategories,
          this.setSelectedCategories,
          isLoading,
          isError,
        )}
        {this.renderLoading(isLoading)}
        {this.renderErrorState(isError, isLoading, onTryAgainPress)}
        {!isLoading && withCategoriesDivider && (
          <View
            style={styles.divider(theme)}
            testID={FrameworkTestKeys.BalanceHistoryCategoriesDivider}
          />
        )}
        {!_.isEmpty(dateFilterPeriod) &&
          (_.isEmpty(balanceData) || _.isEmpty(balanceItems)) &&
          _.isFunction(renderTimePeriodNoBalanceHistory) &&
          renderTimePeriodNoBalanceHistory()}
        {this.renderBalanceList(isError, isLoading)}
      </ScrollView>
    );
  }
}
Balance.defaultProps = {
  theme: LightThemeColors,
  isNoBalanceHistory: false,
  onTryAgainPress: () => { },
  images: {},
  dateFilterPeriod: {},
};

Balance.propTypes = {
  withTray: PropTypes.bool,
  withCategories: PropTypes.bool,
  isNoBalanceHistory: PropTypes.bool,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onTryAgainPress: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  images: PropTypes.object,
  balanceData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          content: PropTypes.string,
          date: PropTypes.string,
          icon: PropTypes.string,
          duration: PropTypes.string,
          price: PropTypes.string,
          type: PropTypes.string,
          recurring: PropTypes.bool,
          transactionStatus: PropTypes.string,
        }),
      ),
    }),
  ),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  getBalanceData: PropTypes.func,
  getBalanceFilteredData: PropTypes.func,
  withAutoTopUpCard: PropTypes.bool,
  autoTopUpCardProps: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    isAutoTopUpActivated: PropTypes.bool,
    onToggleActiveStatus: PropTypes.func,
  }),
  dateFilterPeriod: PropTypes.shape({
    selectedPeriod: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
  }),
  onBalanceHistoryDatesPress: PropTypes.func,
  withCategoriesDivider: PropTypes.bool,
  renderTimePeriodNoBalanceHistory: PropTypes.func,

  // DEPRECATEME: since [Release 22]
  withAutoTopUpBanner: PropTypes.bool,
  autoTopUpBannerProps: PropTypes.shape({
    backgroundColors: PropTypes.array,
    title: PropTypes.string,
    description: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    onPrimaryButtonPress: PropTypes.func,
  }),
};
export { Balance };
export default withTheme(Balance);
